import cx from 'classnames';
import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import type { TeamTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './WorkspaceMembersFilterList.less';

interface WorkspaceMembersFilterListProps {
  memberTypeFilter: string;
  onMemberTypeChange: (string: string) => void;
  orgMemberCount: number;
  guestMemberCount: number;
  requestMemberCount: number;
  showGuestTab: boolean;
  showRequestTab: boolean;
  isFetchingCollaborators: boolean;
}

export const WorkspaceMembersFilterList: FunctionComponent<
  WorkspaceMembersFilterListProps
> = ({
  memberTypeFilter,
  onMemberTypeChange,
  orgMemberCount,
  guestMemberCount,
  requestMemberCount,
  showGuestTab,
  showRequestTab,
  isFetchingCollaborators,
}) => {
  return (
    <div className={styles.filterList}>
      <ul className={styles.filter}>
        <li>
          <a
            href="#"
            data-testid={getTestId<TeamTestIds>('team-members-link')}
            onClick={(e) => {
              e.preventDefault();
              onMemberTypeChange('team-member');
            }}
            className={cx({
              [styles.active]: memberTypeFilter === 'team-member',
            })}
          >
            <FormattedMessage
              id="templates.org_members.workspace-members-count"
              defaultMessage="Workspace members ({count})"
              description="Workspace members count"
              values={{ count: orgMemberCount }}
            />
          </a>
        </li>
        {showGuestTab && (
          <li>
            <a
              href="#"
              data-testid={getTestId<TeamTestIds>('team-members-link')}
              onClick={(e) => {
                e.preventDefault();
                onMemberTypeChange('guest');
              }}
              className={cx({
                [styles.active]: memberTypeFilter === 'guest',
              })}
            >
              <FormattedMessage
                id="templates.org_members.guests-count"
                defaultMessage="Guests ({count})"
                description="Guests count"
                values={{
                  count: isFetchingCollaborators ? '...' : guestMemberCount,
                }}
              />
            </a>
          </li>
        )}
        {showRequestTab && (
          <hr role="presentation" className={styles.horizontalSeparator} />
        )}
        {showRequestTab && (
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onMemberTypeChange('request');
              }}
              className={cx({
                [styles.active]: memberTypeFilter === 'request',
              })}
            >
              <FormattedMessage
                id="templates.org_members.join-requests-count"
                defaultMessage="Join requests ({count})"
                description="Join requests count"
                values={{
                  count: isFetchingCollaborators ? '...' : requestMemberCount,
                }}
              />
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
